import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sof7: FaireReviewEntity = {
  token: "review_sof7",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "product",
  productToken: "p_jysdty2vvp",
  reviewerName: "Alexandra",
  reviewerLocation: "Kodiak, AK",
  stars: 5,
  reviewText: "Softies are amazing. Super soft and great quality.",
  reviewDate: "Jan 3, 2025",
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
